import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            dark: {
                primary: '#fff',
                secondary: '#26a69a',
                tertiary: '36404a',
                quaternary: '#4C5965',
                accent: colors.teal.accent3,
                warning: '#ff5252',
                error: '#ff2a2a',
                deleteIcon: '#e61f40',
                cardPurple: '#4527A0',
                cardIndigo: '#283593',
                cardBlue: '#1565C0',
                cardCyan: '#00838F'
            },
            light: {
                primary: '#222',
                secondary: '#26a69a',
                //secondary: '#38414a',
                tertiary: '#fff',
                quaternary: '#6b7b8a',
                accent: colors.teal.accent3,
                warning: '#ff5252',
                error: '#f11e53',
                deleteIcon: '#e61f40',
                cardPurple: '#D1C4E9',
                cardIndigo: '#C5CAE9',
                cardBlue: '#BBDEFB',
                cardCyan: '#B2EBF2'
            }
        }
    },
    icons: {
        iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg',
        values: {
            person: 'mdi-email',
            password: 'mdi-textbox-password'
        }
    }
});
